import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer } from 'react-toastify';

import ProtectedRoute from './components/protection/protectionRoute';
import ProtectedRouteUserToSubmaster from './components/protection/protectionRouteUserToSubmaster';
import RouteTransition from './components/ui/RouteTransition';
import AppLoader from './components/ui/AppLoader';
import MutationActionLoader from './components/ui/MutationActionLoader';

import AuthenticationPage from './page/auth/AuthenticationPage';
import AuthUserToSubmasterPage from './page/authUserSubmaster/AuthUserToSubmasterPage';
import LandingPage from './page/landing/LandingPage';

import HomePage from './page/dashboardSubmaster/HomePage';
import RegionForm from './page/dashboardSubmaster/RegionForm';
import UnitForm from './page/dashboardSubmaster/UnitFormPage';
import LocalForm from './page/dashboardSubmaster/LocalForm';
import UploadPage from './page/dashboardSubmaster/UploadPage';
import SeeContractPage from './page/dashboardSubmaster/SeeContractPage';
import ReportPage from './page/dashboardSubmaster/Report';
import NotificationPage from './page/dashboardSubmaster/Notificaiton';
import PlanSubmasterPage from './page/dashboardSubmaster/PlanSubmasterPage';
import UserPage from './page/dashboardSubmaster/UserPage';
import CompanyPage from './page/dashboardSubmaster/CompanyPage';
import HistoryPage from './page/dashboardSubmaster/HistoryPage';
import AgendaPage from './page/dashboardSubmaster/AgendaPage';
import { UserProvider } from './page/dashboardSubmaster/UserProvider';

import HomeUserToSubmasterPage from './page/dashboardUserToSubmaster/HomeUserToSubmasterPage';
import UploadPageSubmaster from './page/dashboardUserToSubmaster/UploadPageSubmaster';
import SeeContractPageSubmaster from './page/dashboardUserToSubmaster/SeeContractPageSubmaster';
import UserPageSubmaster from './page/dashboardUserToSubmaster/UserPageSubmaster';
import CompanyPageSubmaster from './page/dashboardUserToSubmaster/CompanyPageSubmaster';
import RegionFormSubmaster from './page/dashboardUserToSubmaster/RegionFormSubmaster';
import UnitFormSubmaster from './page/dashboardUserToSubmaster/UnitFormPageSubmaster';
import NotificationPageSubmaster from './page/dashboardUserToSubmaster/NotificaitonSubmaster';
import ReportPageSubmaster from './page/dashboardUserToSubmaster/ReportSubmaster';
import AgendaPageSubmaster from './page/dashboardUserToSubmaster/AgendaPageSubmaster';
import { UserProviderloginSubmaster } from './page/dashboardUserToSubmaster/UserProviderloginSubmaster';

import './styles/modern-theme.css';
import { ThemeProvider } from './theme/ThemeContext';

function withTransition(page: React.ReactNode) {
  return <RouteTransition>{page}</RouteTransition>;
}

function App() {
  const [isBootLoading, setIsBootLoading] = useState(true);

  useEffect(() => {
    const timer = window.setTimeout(() => setIsBootLoading(false), 1400);
    return () => window.clearTimeout(timer);
  }, []);

  if (isBootLoading) {
    return <AppLoader label="INICIALIZANDO SISTEMA" />;
  }

  return (
    <BrowserRouter>
      <UserProvider>
        <Routes>
          <Route path="/" element={withTransition(<LandingPage />)} />
          <Route path="/auth" element={withTransition(<AuthenticationPage />)} />

          <Route
            path="/HomePage"
            element={<ProtectedRoute>{withTransition(<HomePage />)}</ProtectedRoute>}
          />
          <Route
            path="/RegionForm"
            element={<ProtectedRoute>{withTransition(<RegionForm />)}</ProtectedRoute>}
          />
          <Route
            path="/UnitForm"
            element={<ProtectedRoute>{withTransition(<UnitForm />)}</ProtectedRoute>}
          />
          <Route
            path="/LocalForm"
            element={<ProtectedRoute>{withTransition(<LocalForm />)}</ProtectedRoute>}
          />
          <Route
            path="/UploadPage"
            element={<ProtectedRoute>{withTransition(<UploadPage />)}</ProtectedRoute>}
          />
          <Route
            path="/SeeContractPage"
            element={<ProtectedRoute>{withTransition(<SeeContractPage />)}</ProtectedRoute>}
          />
          <Route
            path="/ReportPage"
            element={<ProtectedRoute>{withTransition(<ReportPage />)}</ProtectedRoute>}
          />
          <Route
            path="/NotificationPage"
            element={<ProtectedRoute>{withTransition(<NotificationPage />)}</ProtectedRoute>}
          />
          <Route
            path="/PlanSubmasterPage"
            element={<ProtectedRoute>{withTransition(<PlanSubmasterPage />)}</ProtectedRoute>}
          />
          <Route
            path="/UserPage"
            element={<ProtectedRoute>{withTransition(<UserPage />)}</ProtectedRoute>}
          />
          <Route
            path="/CompanyPage"
            element={<ProtectedRoute>{withTransition(<CompanyPage />)}</ProtectedRoute>}
          />
          <Route
            path="/HistoryPage"
            element={<ProtectedRoute>{withTransition(<HistoryPage />)}</ProtectedRoute>}
          />
          <Route
            path="/AgendaPage"
            element={<ProtectedRoute>{withTransition(<AgendaPage />)}</ProtectedRoute>}
          />
        </Routes>
      </UserProvider>

      <UserProviderloginSubmaster>
        <Routes>
          <Route
            path="/AuthUserToSubmasterPage"
            element={withTransition(<AuthUserToSubmasterPage />)}
          />
          <Route
            path="/HomeUserToSubmasterPage"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<HomeUserToSubmasterPage />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/UploadPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<UploadPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/SeeContractPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<SeeContractPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/UserPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<UserPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/CompanyPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<CompanyPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/UnitFormSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<UnitFormSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/RegionFormSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<RegionFormSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/NotificationPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<NotificationPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/ReportPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<ReportPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
          <Route
            path="/AgendaPageSubmaster"
            element={
              <ProtectedRouteUserToSubmaster>
                {withTransition(<AgendaPageSubmaster />)}
              </ProtectedRouteUserToSubmaster>
            }
          />
        </Routes>
      </UserProviderloginSubmaster>

      <ToastContainer position="top-right" theme="colored" />
      <MutationActionLoader />
    </BrowserRouter>
  );
}

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
